<div class="machine-review-container">
  <div class="d-flex justify-content-between justify-content-md-start align-items-baseline">
    <p class="section-header">History</p>
    <!-- <app-star-rating [numberOfStars]="ratingInfo.overall" fontSize="20px"></app-star-rating> -->
  </div>
  <p>Summary</p>
  <div class="d-flex justify-content-between mb-3">
    <div class="d-flex flex-column align-items-center third-width">
      <div class="fs-40 text-primary" *ngIf="machine.viewsTotal >= 100">{{ machine.viewsTotal }}</div>
      <div class="fs-40 text-primary" *ngIf="machine.viewsTotal < 100">< 100</div>
      <div class="font-weight-light text-center">Views</div>
    </div>
    <ng-container *ngIf="!machine.buyItNowOnly">
      <div class="d-flex flex-column align-items-center third-width">
        <div class="fs-40 text-primary">{{ numberOfCancels }}</div>
        <div class="font-weight-light">Cancellation<ng-container *ngIf="numberOfCancels != 1">s</ng-container></div>
      </div>
      <!-- <div class="d-flex flex-column align-items-center third-width">
        <div class="fs-40 text-primary">4hrs</div>
        <div class="text-center font-weight-light">Avg. Response Time</div>
      </div> -->
    </ng-container>
  </div>

  <ng-container *ngIf="!machine.buyItNowOnly">
    <p>Reviews</p>
    <p class="font-weight-light mb-0" *ngIf="reviews?.length == 0">This machine does not have any reviews.</p>
    <div class="row">
      <div class="col-md-12">
        <ng-container *ngFor="let review of reviews; last as isLast">
          <div class="machine-review-card-container pt-3">
            <common-user-avatar
              [header]="review.header"
              [subHeader]="review.subHeader"
              imageUrl="https://company.rubbl.com/pubweb/marketplace/images/icons/rubbl.svg"
            ></common-user-avatar>
          </div>
          <div class="bb-light" *ngIf="!isLast"></div>
        </ng-container>
      </div>
    </div>
  </ng-container>
  <!-- <div *ngIf="reviews.length == 0" class="alert alert-success" role="alert">Be the first to rent this machine!</div> -->
</div>

<!-- <div class="row">
    <div class="col-md-6">
      <div class="d-flex justify-content-between align-items-baseline mt-3">
        <h6>Experience</h6>
        <app-star-rating [numberOfStars]="ratingInfo.experience" fontSize="16px"></app-star-rating>
      </div>

      <div class="d-flex justify-content-between align-items-baseline mt-3">
        <h6>Machine</h6>
        <app-star-rating [numberOfStars]="ratingInfo.machine" fontSize="16px"></app-star-rating>
      </div>

      <div class="d-flex justify-content-between align-items-baseline mt-3">
        <h6>Accuracy</h6>
        <app-star-rating [numberOfStars]="ratingInfo.accuracy" fontSize="16px"></app-star-rating>
      </div>
    </div>
    <div class="col-md-6">
      <div class="d-flex justify-content-between align-items-baseline mt-3">
        <h6>Value</h6>
        <app-star-rating [numberOfStars]="ratingInfo.value" fontSize="16px"></app-star-rating>
      </div>

      <div class="d-flex justify-content-between align-items-baseline mt-3">
        <h6>Communication</h6>
        <app-star-rating [numberOfStars]="ratingInfo.communication" fontSize="16px"></app-star-rating>
      </div>

      <div class="d-flex justify-content-between align-items-baseline mt-3">
        <h6>Inspection</h6>
        <app-star-rating [numberOfStars]="ratingInfo.inspection" fontSize="16px"></app-star-rating>
      </div>
    </div>
  </div> -->
